import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectActiveEntitiesArray } from '../../services/entities/selectors';
import { makeSelectEntityTypeValue } from '../../services/entityTypes/selectors';

// Utils
import orderBy from '../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
const selectEntityTypeId = (state, props) => props.entityTypeId;

const selectFilteredData = createDeepEqualSelector(
    [selectActiveEntitiesArray, selectEntityTypeId],
    (activeEntitiesArray, entityTypeIdState) =>
        activeEntitiesArray.filter(value => {
            if (entityTypeIdState && entityTypeIdState !== value.entityTypeId) {
                return false;
            }
            return true;
        })
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'name')
);

const selectOptions = createDeepEqualSelector(
    [selectOrderedData, makeSelectEntityTypeValue('pluralName')],
    (orderedDataState, entityTypePluralNameState) =>
        [
            {
                key: 0,
                text: `All ${entityTypePluralNameState}`,
                value: 0
            }
        ].concat(
            orderedDataState.map(({ id, name }) => ({
                key: id,
                text: name,
                value: id
            }))
        )
);

export { selectOptions };
